// src/components/Comment.js
import React from 'react';

// Helper to format dates nicely
const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit'
  });
};

const Comment = ({ comment }) => {
  return (
    <div className="py-4 border-b border-gray-200 last:border-b-0">
      <div className="flex items-start space-x-3">
        {/* User Avatar/Initial */}
        <div className="flex-shrink-0 w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
          <span className="text-sm font-semibold text-gray-600">
            {comment.user.fullName?.charAt(0).toUpperCase() || '?'}
          </span>
        </div>
        {/* Comment Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <p className="text-sm font-semibold text-gray-900 truncate">
              {comment.user.fullName || 'User'}
            </p>
            <p className="text-xs text-gray-500">
              {formatDate(comment.createdAt)}
            </p>
          </div>
          <p className="text-sm text-gray-700 whitespace-pre-wrap break-words">
            {comment.text}
          </p>

          {/* Admin Reply */}
          {comment.isReplied && comment.reply && (
            <div className="mt-3 pl-4 py-2 border-l-2 border-primary-200 bg-primary-50 rounded-r-lg">
              <div className="flex items-center justify-between mb-1">
                <p className="text-sm font-semibold text-primary-700">
                  Reply
                </p>
                <p className="text-xs text-primary-600">
                  {formatDate(comment.repliedAt)}
                </p>
              </div>
              <p className="text-sm text-primary-800 whitespace-pre-wrap break-words">
                {comment.reply}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Comment;